import { createSlice } from '@reduxjs/toolkit';

export interface RegistrationCompleteState {
  emails: string[];
  isAttending: boolean;
  shouldRedirectToEvent: boolean;
}

interface RegistrationCompleteAction {
  payload: {
    emails: string[];
    isAttending: boolean;
    shouldRedirectToEvent: boolean;
  };
}

export const initialState: RegistrationCompleteState = {
  emails: [],
  isAttending: false,
  shouldRedirectToEvent: false,
};

const slice = createSlice({
  name: 'registrationComplete',
  initialState,
  reducers: {
    registrationComplete(
      state: RegistrationCompleteState,
      { payload }: RegistrationCompleteAction,
    ) {
      state.emails = payload.emails;
      state.isAttending = payload.isAttending;
      state.shouldRedirectToEvent = payload.shouldRedirectToEvent;
    },
  },
});

export const { registrationComplete } = slice.actions;
export const { reducer } = slice;
